import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Story} from "../../interfaces/story";
import {OverlayService} from "../../overlay/overlay.service";
import {Router} from "@angular/router";
import {InsightsOverviewService} from "../../insights/insights-overview/insights-overview.service";
import {ProfessionsService} from "../../services/professions.service";
import {JobService} from "../../services/job.service";
import {ProvidersService} from "../../services/providers.service";
import {ProviderTypes} from "../../enums/provider-types";

@Component({
  selector: 'brt-story-footer',
  templateUrl: './story-footer.component.html',
  styleUrls: ['./story-footer.component.scss']
})
export class StoryFooterComponent {
  @Output('onClosed') onClosed = new EventEmitter<void>();
  @Input('story') story!: Story

  constructor(private overlayService: OverlayService,
              private router: Router,
              private insightsOverviewService: InsightsOverviewService,
              private professionsService: ProfessionsService,
              private jobsService: JobService,
              private providersService: ProvidersService) {
  }

  onMenuItemClicked() {
    this.onClosed.emit();
  }
  openStoriesOverviewByFilter() {
    this.onMenuItemClicked();
    this.insightsOverviewService.setInsightsFilter(this.story.portrait, 1);
  }

  openRelatedProfession() {
    if(this.story.bicId > 0) {
      this.router.navigateByUrl(this.professionsService.getProfessionUrlById(this.story.bicId));
    }
    this.onMenuItemClicked();
  }

  openRelatedJobsOverview() {
    this.onMenuItemClicked();
    this.router.navigateByUrl('/' + this.jobsService.getFilterUrl(1, [], [], "", [], "", 0, "", false, false, this.story.bicId,  {lat: 0, lng: 0}));
  }

  openTrainingCompaniesOverview() {
    this.onMenuItemClicked();
    this.router.navigateByUrl('/' + this.providersService.getFilterUrl(1, [], [], [], "", [], "", 0, "", false, false, this.story.bicId, {lat: 0, lng: 0}));
  }

  openSchoolsOverview() {
    this.onMenuItemClicked();
    if(this.story.schoolProfileUuid.length) {
      this.router.navigateByUrl(this.providersService.getProviderDetailPageUrlById(this.story.schoolProfileUuid, ProviderTypes.SCHOOL));
    }
  }
}
